export default "__VITE_ASSET__29809442__"